var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBiEye(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_126_457)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.4655 11.8496C23.4655 11.8496 19.153 3.94335 11.9655 3.94335C4.77795 3.94335 0.465454 11.8496 0.465454 11.8496C0.465454 11.8496 4.77795 19.7559 11.9655 19.7559C19.153 19.7559 23.4655 11.8496 23.4655 11.8496ZM2.15164 11.8496C2.84669 10.7932 3.64613 9.80934 4.53789 8.91279C6.38795 7.05985 8.91795 5.38085 11.9655 5.38085C15.013 5.38085 17.5415 7.05985 19.3945 8.91279C20.2862 9.80934 21.0857 10.7932 21.7807 11.8496C21.6973 11.9747 21.6053 12.1127 21.5004 12.2636C21.0188 12.9536 20.3073 13.8736 19.3945 14.7864C17.5415 16.6394 15.0115 18.3184 11.9655 18.3184C8.91795 18.3184 6.38939 16.6394 4.53645 14.7864C3.6447 13.8899 2.84526 12.906 2.1502 11.8496H2.15164Z",
    fill: "#BABABA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9655 8.25586C11.0123 8.25586 10.0982 8.63448 9.42429 9.30844C8.75033 9.9824 8.3717 10.8965 8.3717 11.8496C8.3717 12.8027 8.75033 13.7168 9.42429 14.3908C10.0982 15.0647 11.0123 15.4434 11.9655 15.4434C12.9186 15.4434 13.8327 15.0647 14.5066 14.3908C15.1806 13.7168 15.5592 12.8027 15.5592 11.8496C15.5592 10.8965 15.1806 9.9824 14.5066 9.30844C13.8327 8.63448 12.9186 8.25586 11.9655 8.25586ZM6.9342 11.8496C6.9342 10.5152 7.46428 9.23552 8.40782 8.29197C9.35137 7.34843 10.6311 6.81836 11.9655 6.81836C13.2998 6.81836 14.5795 7.34843 15.5231 8.29197C16.4666 9.23552 16.9967 10.5152 16.9967 11.8496C16.9967 13.184 16.4666 14.4637 15.5231 15.4072C14.5795 16.3508 13.2998 16.8809 11.9655 16.8809C10.6311 16.8809 9.35137 16.3508 8.40782 15.4072C7.46428 14.4637 6.9342 13.184 6.9342 11.8496Z",
    fill: "#BABABA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_126_457"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 23,
    fill: "white",
    transform: "translate(0.465454 0.349609)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBiEye);
export default __webpack_public_path__ + "static/media/bi_eye.8f1fe0b2.svg";
export { ForwardRef as ReactComponent };